import {useEffect, useState} from "react";
import {WithSlider} from "./WithSlider";
import {WithoutSlider} from "./WithoutSlider";
import st from './Agent.module.scss'
import {isPad, windowResize} from 'helpers';
import {useAppContext} from 'Context'
import { content } from './default'
import useSWR from 'swr';
import axios from 'axios';
import {Spinner} from 'components/Spinner/Spinner';

export const Agent = ()=> {
    const { region, mapOptions: { setSelect } } = useAppContext()
    const { data, isLoading } = useSWR('/erdb/region/person?region_id='+region?.id, axios.get, {
        onSuccess() {
            setSelect(region)
        }
    })

    const [hasPad, setHasPad] = useState(isPad)
    useEffect(() => windowResize(setHasPad, 1024), [setHasPad]);
    const actual = !isLoading && (!!data?.data?.data.length || region?.id !== 0) ? data?.data?.data : content
    
    return (
        <div className={st.agent}>
            {isLoading && <div className={st.loader}><Spinner cn={st.spin} /></div>}
            {hasPad ? <WithSlider data={actual} /> : <WithoutSlider data={actual} region={region?.id} />}
        </div>
    )
}
